export const SET_ROLES_LIST = "SET_ROLES_LIST";
export const UPDATE_ROLES_LIST = "UPDATE_ROLES_LIST";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";
